import React, { Component } from "react";
import { FormComponent } from "./FormComponent";
import { urlPath } from "../../Settings";

const url = urlPath + "/api/custommappings?";
const deleteUrl = urlPath + "/api/custommappings/";
const saveUrl = urlPath + "/api/custommappings/";

class FormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      destinationValue: "",
      sourceValue: ""
    };
  }

  componentDidMount() {
    const { type, destinationValue, sourceValue } = this.props;
    this.setState({
      destinationValue,
      sourceValue
    });
  }

  onSave = e => {
    this.submitConfig(
      url +
        "type=" +
        this.props.type +
        "&source=" +
        this.state.sourceValue +
        "&destination=" +
        this.state.destinationValue,
      "POST"
    );
  };
  onUpdate = e => {
    this.submitConfig(
      saveUrl +
        this.props.id +
        "?source=" +
        this.state.sourceValue +
        "&destination=" +
        this.state.destinationValue,
      "PATCH"
    );
  };
  onDelete = () => {
    this.deleting();
    fetch(deleteUrl + this.props.id, {
      method: "DELETE",
      credentials: "include"
    })
      .then(response => {
        const deleted = true;
        this.fetchSucceed(deleted);
      })
      .catch(e => this.fetchErrored());
  };
  fetching = () => {
    this.setState({ processing: true, disabled: true });
  };
  deleting = () => {
    this.setState({ deleting: true, disabled: true });
  };
  fetchSucceed = deleted => {
    const { newForm } = this.props;
    this.setState({
      deleted,
      deleting: false,
      processing: false,
      disabled: newForm,
      fetchSucceed: true
    });
    this.props.loadCustomMappings(this.props.type);
  };
  fetchErrored = () => {
    this.setState({ processing: false, disabled: false, fetchErrored: true });
  };
  checkValues = () => {
    const { destinationValue, sourceValue } = this.state;
    if (destinationValue.length < 1 || sourceValue.length < 1) {
      this.setState({ invalid: true });
      return false;
    }
    return true;
  };
  submitConfig = (url, method) => {
    if (this.checkValues()) {
      this.fetching();
      fetch(url, {
        method: method,
        credentials: "include"
      })
        .then(response => {
          this.fetchSucceed();
          if (method === "POST") {
            this.props.addForm();
          }
        })
        .catch(e => this.fetchErrored());
    }
    return;
  };
  onDestinationChange = e => {
    this.setState({
      destinationValue: e.target.value
    });
  };
  onDestinationSelect = val => {
    console.log(val);
    this.setState({
      destinationValue: val
    });
  };
  onSourceChange = e => {
    this.setState({
      sourceValue: e.target.value
    });
  };
  render() {
    const {
      disabled,
      processing,
      fetchSucceed,
      fetchErrored,
      destinationValue,
      sourceValue,
      deleted,
      deleting
    } = this.state;
    const { type, id, newForm } = this.props;
    return (
      <FormComponent
        id={id}
        type={type}
        newForm={newForm}
        onDelete={this.onDelete}
        onSave={this.onSave}
        onUpdate={this.onUpdate}
        deleting={deleting}
        deleted={deleted}
        disabled={disabled}
        destinationValue={destinationValue}
        fetchSucceed={fetchSucceed}
        fetchErrored={fetchErrored}
        onSourceChange={this.onSourceChange}
        onDestinationChange={this.onDestinationChange}
        onDestinationSelect={this.onDestinationSelect}
        processing={processing}
        sourceValue={sourceValue}
      />
    );
  }
}

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Form/FormContainer.js